import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { initSentry } from './lib/sentry'
import { initPostHog } from './lib/posthog'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store/store'
import { AuthProvider } from './lib/auth'
import { AuthGate } from './components/AuthGate'
import { ShoppingListsBootstrap } from './sync/ShoppingListsBootstrap'
import { LocaleBootstrap } from './i18n/LocaleBootstrap'
import { ToastProvider } from './components/Toast'
import './index.css'
import App from './App.tsx'

// Start error/perf monitoring + product analytics before anything renders.
initSentry()
initPostHog()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthProvider>
          <ShoppingListsBootstrap />
          <LocaleBootstrap />
          <AuthGate>
            <ToastProvider>
              <App />
            </ToastProvider>
          </AuthGate>
        </AuthProvider>
      </PersistGate>
    </Provider>
  </StrictMode>,
)
